// Most somersaults exist once per shape ("Back (T)", "Back (P)", "Back (S)").
// Group them so the skill picker can show one row with a button per shape.
const SHAPE_SUFFIX = /\s*\(([TPS])\)\s*$/i;
const ORDER = { T: 0, P: 1, S: 2 };

const shapeOf = (name) => {
  const m = (name || '').match(SHAPE_SUFFIX);
  return m ? m[1].toUpperCase() : null;
};
const baseOf = (name) => (name || '').replace(SHAPE_SUFFIX, '').trim();

export function groupShapeVariants(skills) {
  const groups = new Map();
  skills.forEach((skill, i) => {
    const shape = shapeOf(skill.name);
    const key = shape ? `shape:${baseOf(skill.name).toLowerCase()}` : `single:${skill.id ?? i}`;
    if (!groups.has(key)) groups.set(key, { key, base: shape ? baseOf(skill.name) : skill.name.trim(), variants: [] });
    groups.get(key).variants.push({ shape, skill });
  });
  return [...groups.values()].map(g => ({
    ...g,
    variants: g.variants.slice().sort((a, b) => (ORDER[a.shape] ?? 9) - (ORDER[b.shape] ?? 9)),
  }));
}

// FIG without its trailing shape character, for showing under a grouped row.
export function figStem(fig) {
  return (fig || '').replace(/[o<\/v]$/, '');
}
